import { defaultTheme, possibleColors, possibleWebColors } from '@mnd-frontend/ui/shared/tokens';
import type { IconColor } from './type';

export const iconColorMap: Record<IconColor, string> = {
  RED_100: possibleColors.RED_100,
  RED_200: possibleColors.RED_200,
  RED_300: possibleColors.RED_300,
  RED_400: possibleColors.RED_400,
  RED_500: possibleColors.RED_500,
  RED_600: possibleColors.RED_600,
  RED_700: possibleColors.RED_700,
  RED_800: possibleColors.RED_800,
  RED_900: possibleColors.RED_900,
  RED_1000: possibleColors.RED_1000,
  PURPLE_100: possibleColors.PURPLE_100,
  PURPLE_200: possibleColors.PURPLE_200,
  PURPLE_300: possibleColors.PURPLE_300,
  PURPLE_400: possibleColors.PURPLE_400,
  PURPLE_500: possibleColors.PURPLE_500,
  PURPLE_600: possibleColors.PURPLE_600,
  PURPLE_700: possibleColors.PURPLE_700,
  PURPLE_800: possibleColors.PURPLE_800,
  PURPLE_900: possibleColors.PURPLE_900,
  PURPLE_1000: possibleColors.PURPLE_1000,
  WARNING_100: possibleColors.WARNING_100,
  WARNING_200: possibleColors.WARNING_200,
  WARNING_300: possibleColors.WARNING_300,
  WARNING_400: possibleColors.WARNING_400,
  WARNING_500: possibleColors.WARNING_500,
  WARNING_600: possibleColors.WARNING_600,
  WARNING_700: possibleColors.WARNING_700,
  WARNING_800: possibleColors.WARNING_800,
  WARNING_900: possibleColors.WARNING_900,
  WARNING_1000: possibleColors.WARNING_1000,
  DANGER_100: possibleColors.DANGER_100,
  DANGER_200: possibleColors.DANGER_200,
  DANGER_300: possibleColors.DANGER_300,
  DANGER_400: possibleColors.DANGER_400,
  DANGER_500: possibleColors.DANGER_500,
  DANGER_600: possibleColors.DANGER_600,
  DANGER_700: possibleColors.DANGER_700,
  DANGER_800: possibleColors.DANGER_800,
  DANGER_900: possibleColors.DANGER_900,
  DANGER_1000: possibleColors.DANGER_1000,
  GREY_100: possibleColors.GREY_100,
  GREY_200: possibleColors.GREY_200,
  GREY_300: possibleColors.GREY_300,
  GREY_400: possibleColors.GREY_400,
  GREY_500: possibleColors.GREY_500,
  GREY_600: possibleColors.GREY_600,
  GREY_700: possibleColors.GREY_700,
  GREY_800: possibleColors.GREY_800,
  GREY_900: possibleColors.GREY_900,
  GREY_1000: possibleColors.GREY_1000,
  NEUTRAL_WHITE: possibleColors.NEUTRAL_WHITE,
  SUCCESS_100: possibleColors.SUCCESS_100,
  SUCCESS_200: possibleColors.SUCCESS_200,
  SUCCESS_300: possibleColors.SUCCESS_300,
  SUCCESS_400: possibleColors.SUCCESS_400,
  SUCCESS_500: possibleColors.SUCCESS_500,
  SUCCESS_600: possibleColors.SUCCESS_600,
  SUCCESS_700: possibleColors.SUCCESS_700,
  SUCCESS_800: possibleColors.SUCCESS_800,
  SUCCESS_900: possibleColors.SUCCESS_900,
  SUCCESS_1000: possibleColors.SUCCESS_1000,
  TEAL_100: possibleColors.TEAL_100,
  TEAL_200: possibleColors.TEAL_200,
  TEAL_300: possibleColors.TEAL_300,
  TEAL_400: possibleColors.TEAL_400,
  TEAL_500: possibleColors.TEAL_500,
  TEAL_600: possibleColors.TEAL_600,
  TEAL_700: possibleColors.TEAL_700,
  TEAL_800: possibleColors.TEAL_800,
  TEAL_900: possibleColors.TEAL_900,
  TEAL_1000: possibleColors.TEAL_1000,
  SOCIAL_FACEBOOK: possibleColors.SOCIAL_FACEBOOK,
  SOCIAL_TWITTER: possibleColors.SOCIAL_TWITTER,
  SOCIAL_X: possibleColors.SOCIAL_X,
  SOCIAL_LINKEDIN: possibleColors.SOCIAL_LINKEDIN,
  SOCIAL_GOOGLE: possibleColors.SOCIAL_GOOGLE,
  SOCIAL_YOUTUBE: possibleColors.SOCIAL_YOUTUBE,
  colorIconsDefault: defaultTheme.colorIconsDefault,
  colorIconsInfo: defaultTheme.colorIconsInfo,
  colorIconsWarning: defaultTheme.colorIconsWarning,
  colorIconsDanger: defaultTheme.colorIconsDanger,
  colorIconsOnDark: defaultTheme.colorIconsOnDark,
  colorIconsSuccess: defaultTheme.colorIconsSuccess,
  colorIconsNavigationPrimary: defaultTheme.colorIconsNavigationPrimary,
  WEB_RED_REG: possibleWebColors.WEB_RED_REG,
  WEB_RED_MID: possibleWebColors.WEB_RED_MID,
  WEB_RED_LT: possibleWebColors.WEB_RED_LT,
  WEB_RED_EXTRA_LIT: possibleWebColors.WEB_RED_EXTRA_LIT,
  WEB_PURPLE_REG: possibleWebColors.WEB_PURPLE_REG,
  WEB_PURPLE_MID: possibleWebColors.WEB_PURPLE_MID,
  WEB_PURPLE_LT: possibleWebColors.WEB_PURPLE_LT,
  WEB_PURPLE_EXTRA_LIT: possibleWebColors.WEB_PURPLE_EXTRA_LIT,
  WEB_GREY_DK: possibleWebColors.WEB_GREY_DK,
  WEB_GREY_REG: possibleWebColors.WEB_GREY_REG,
  WEB_GREY_LT: possibleWebColors.WEB_GREY_LT,
  WEB_WHITE_REG: possibleWebColors.WEB_WHITE_REG,
  WEB_ORANGE_REG: possibleWebColors.WEB_ORANGE_REG,
} as const;
